import type { components } from "@/api/schema";

export type ShadowJob = components["schemas"]["ShadowPlanOutput"];
export type ShadowPlan = components["schemas"]["PlanEstimate"];
export type ShadowStep = components["schemas"]["StepEstimate"];

/** Adjacent quick sells share one row, like v1. */
export function groupShadowSteps(steps: ShadowStep[]) {
	const groups: ShadowStep[][] = [];
	for (const step of steps) {
		const previous = groups.at(-1);
		if (
			step.suggestion.method === "QUICK_SELL" &&
			previous?.[0].suggestion.method === "QUICK_SELL"
		) {
			previous.push(step);
		} else groups.push([step]);
	}
	let position = 0;
	return groups.map((steps) => {
		const start = position + 1;
		position += steps.length;
		return { steps, start, end: position };
	});
}

export function savingsPercentage(
	v1: ShadowPlan | undefined,
	saving: number | null | undefined,
) {
	return v1?.complete && v1.expected_completion_cost > 0 && saving != null
		? (saving / v1.expected_completion_cost) * 100
		: null;
}
